import { SELECTED_ITEM_TYPE } from "@/3d/SelectedItem";
import { useDemoState } from "@/state/demoState";
import { WallPropConfig } from "@/state/RoomConfig/WallConfig";
import { useMemo } from "react";

export const useWallPropData = (prop: WallPropConfig) => {
    const selectedItem = useDemoState((state) => state.selectedItem);

    const isSelected =
        selectedItem !== undefined &&
        selectedItem.selectedItemType === SELECTED_ITEM_TYPE.WALL_PROP &&
        selectedItem.key === prop.key;

    const { position, floorOffset } = useMemo(() => {
        const position = prop.offset + prop.width / 2;
        const floorOffset = prop.type === "window" ? prop.floorOffset : 0;

        return { position, floorOffset };
    }, [prop]);

    return { position, floorOffset, isSelected };
};
